import originalFields from 'components/forms/application_original/fields';
import definedSchemas from '../fields/definedSchemas';

const fields = {
    endorsement_text: {
        ...originalFields.endorsement_text,
    },
    renewal_waive_post_date_checkbox: {
        ...definedSchemas.boolRequired,
        section: 'Payment And Delivery',
        label: 'For your current job, do you need your renewed MMC to be valid before your current one expires?',
        initialValue: false,
    },
};

export default fields;
